import React, {useContext} from 'react';
import logo from './../images/EDVES-LOGO 2.png';
import defaultPic from '../images/defaultPic.png';
import { useHistory } from 'react-router-dom';
import HamburgerSvg from '../svg/HamburgerSvg';
import {DataContext} from '../context/DataContext';

const TestNav = ({handleStartTest}) => {
    const history = useHistory();
    const dataContext = useContext(DataContext)
  const showMenu = dataContext.showMenu
  const setDisplaySidebar = () => {
    dataContext.setShowMenu(!showMenu);
  }
    return (
        <>
            <nav className="flex fixed top-0 z-50 border-b border-gray-700 w-full justify-between px-4 bg-white h-16 items-center">
                <div onClick={() => setDisplaySidebar()} className='block sm:hidden cursor-pointer'>
                    <HamburgerSvg />
                </div>
                <div className="logoSize">
                    <img src={logo} alt='logo' className="h-full w-full object-cover" />
                </div>
                <span className="hidden sm:block ml-16 text-gray-200 font-semibold text-sm leading-5"> Edves Academy Student Portal </span>
                <div className='flex items-center'>
                    <span onClick={handleStartTest} className='hidden sm:block bg-blue-800 mr-8 px-10 py-2 text-xs text-blue-100 font-semibold leading-4 cursor-pointer rounded-sm'> 
                    Start Test   
                    </span>
                    <div className="w-10 h-10" >
                        <img src={defaultPic} alt='logo' className="h-full w-full object-cover rounded-full" />
                    </div>
                </div>
            </nav>
        </>
    )
}

export default TestNav;